// extracted by mini-css-extract-plugin
module.exports = {"end_tip":"FJScrollEndTip_end_tip__3MORT","active":"FJScrollEndTip_active__3L-GR","scroll_end":"FJScrollEndTip_scroll_end__1lItG","end_list":"FJScrollEndTip_end_list__1GLb-"};